export const AnalyticsConstants = {
  applicationName: 'Connected Home AppBased Auth | https://github.com/RogersCommunications/connectedhome-appbased-auth',
  siteName: 'R',
  userType: 'consumer',
  basePageHierarchy: 'iptv'
}